import gql from 'graphql-tag';

export const GET_NEST_DEVICES = gql`
  {
    serviceProvider(name: nest) {
      devices {
        deviceType
        deviceId
        deviceName
        hasFan
      }
    }
  }
`;

export const UPDATE_SETTING = gql`
  mutation createSvcProviderTriggerSetting($targetId: String!, $deviceUuid: String!, $component: String!, $onAt: Long!){
    createSvcProviderTriggerSetting(
      targetId: $targetId,
      name: nest,
      eventType: "fanOn",
      hysteresisTriggerKind: "RISING",
      deviceUuid: $deviceUuid,
      component: $component,
      onAt: $onAt
    ) {
      targetId
      name
      eventType
      hysteresisTriggerKind
      deviceUuid
      component
      onAt
    }
  }
`;

export const QUERY_NEST_TRIGGER_SETTINGS = gql `
  query nestTriggerSettings($deviceUuid: String!, $targetId: String!) {
    getTriggerSettings(deviceUuid: $deviceUuid, targetId: $targetId, name: nest, eventType: FanOn) {
      triggerUuid,
      comp,
      onAt,
      direction
    }
  }
`;

export const UPSERT_NEST_TRIGGER_SETTINGS = gql`
  mutation upsertNestTriggerSettings($triggerSettings: [TriggerSetting!]!) {
    upsertTriggerSettings(triggerSettings: $triggerSettings)
  }
`;

export const DELETE_NEST_TRIGGER_SETTINGS = gql`
  mutation deleteNestTriggerSettings($triggerIds: [String!]!) {
    deleteTriggerSettings(triggerIds: $triggerIds)
  }
`;

export const DISCONNECT_NEST = gql`
  mutation disconnectNest($deviceUuid: String!) {
    disconnectServiceProvider(name: nest, deviceUuid: $deviceUuid)
  }
`;




// WEBPACK FOOTER //
// ./src/lib/graphQL/nest/queries.js